// ESPEJO AUTOMÁTICO — el canónico es supabase/functions/_shared/notifications/lasRutasRetiradas.ts.
// No se edita a mano: `npm run espejos` lo regenera y `npm run espejos:gate` falla si quedó atrás.

/**
 * Las rutas que un aviso puede traer guardadas y que el panel ya no tiene, con la ruta de hoy.
 *
 * 🚨 POR QUÉ EXISTE (19-oct-2026). Un drop: «le doy clic a la notificación de que llegó a la agencia y
 *    no hace nada». Las plantillas escribían `/m/orders/<id>` —una interfaz móvil retirada cuyo
 *    comodín manda al Inicio— y varias funciones de la base escriben rutas que el panel nunca tuvo
 *    (`/ops/ventas`, `/ajustes/integraciones`). El clic, en la campana y en el push del celular,
 *    terminaba en el Inicio.
 *
 * ⭐ UNA SOLA TABLA PARA LOS DOS LADOS. La usa la plantilla (lo que llega desde la base sale ya
 *    traducido, también al push) y la usa el panel (para las filas que quedaron guardadas con la ruta
 *    vieja: siguen en la campana meses después). Es un espejo: el canónico vive acá y
 *    `npm run espejos` lo copia a `src/lib/avisos/`. Por eso no importa nada.
 */

/**
 * Ruta retirada → ruta de hoy. Si termina en `/` es un prefijo y conserva lo que sigue (el id); si no,
 * vale sólo la ruta exacta: `/m/crm` no puede convertir `/m/crm/leads` en `/apps/crm/leads/leads`.
 */
export const RUTAS_RETIRADAS: ReadonlyArray<readonly [string, string]> = [
  // La interfaz móvil `/m`, retirada el 7-sep-2026.
  ['/m/orders/', '/ventas/orden/'],
  ['/m/orders', '/ventas'],
  ['/m/crm/leads/', '/apps/crm/leads/'],
  ['/m/crm', '/apps/crm/leads'],
  ['/m/home', '/home'],
  // Las que escriben funciones de la base y el panel nunca tuvo.
  ['/ops/ventas', '/ventas'],
  ['/ops/drop', '/ventas/drop'],
  ['/operaciones/entregas', '/entregas'],
  ['/ajustes/integraciones', '/settings/integrations'],
  ['/dropshipping/smartydrop/billetera', '/dropshipping/smartydrop/saldo'],
];

/** La ruta de hoy para una ruta guardada. Lo que no reconoce (una ruta vigente, una dirección externa) pasa igual. */
export function laRutaDeHoy(ruta: string): string {
  const [camino, consulta = ''] = ruta.split('?');
  // `/m/whatsapp?c=<conversación>` era el chat abierto: hoy el chat tiene ruta propia.
  if (camino === '/m/whatsapp') {
    const c = new URLSearchParams(consulta).get('c');
    return c ? `/chats/inbox/${encodeURIComponent(c)}` : '/chats/inbox';
  }
  for (const [vieja, nueva] of RUTAS_RETIRADAS) {
    if (vieja.endsWith('/') ? camino.startsWith(vieja) : camino === vieja) {
      return `${nueva}${camino.slice(vieja.length)}${consulta ? `?${consulta}` : ''}`;
    }
  }
  return ruta;
}
